export class LeadsConstants {
  public static get leads(){
    const configuracao = [
      {
        principal: true,
        nome: "Mapfre",
        identificacao: 'Principal',
        identificacaoLim: 'Principal',
        premio: 0.01,
        lead: true,
        link:'https://www.mapfre.com.br/corretores/cadastro-de-corretores/',
        seguradoraId: 3,
        seguradora: 3,
        retorno: true,
        calculando: false,
        ramos: {
          auto: true,
          moto: true,
          caminhao: true,
          residencial: true,
          condominio: true,
          empresarial: true,
          vida: true,
          acidentesPessoais: true
        },
        mensagem: 'Obtenha também uma cotação da Mapfre Seguros. Basta clicar no botão ao lado e cadastrar-se.',
        showComission: false,

        logo: 'assets/images/logos-seguradoras/seguradora3.png'
      }
    ]

    return configuracao
  }
}
